export const version = '1.8.5';
//# sourceMappingURL=version.js.map